import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../components/ui/button';
import { Separator } from '../../../components/ui/separator';
import {
  SettingsSection,
  SettingsLayout,
} from '../../../components/ui/settings-section';
import Webhooks from './webhooks';
import ZoomIntegration from './ZoomIntegration';
import { config } from '../../../../config';
import ContactSalesDialog from '../../sales/ContactSalesDialog';
import { usePlan } from '../../plan/hooks/plan';

const Integrations: React.FC = () => {
  const { t } = useTranslation();
  const { isPlan } = usePlan();
  const [salesDialogOpen, setSalesDialogOpen] = React.useState(false);

  const handleSalesDialogClose = () => {
    setSalesDialogOpen(false);
  };

  return (
    <SettingsLayout>
      <div className="space-y-4">
        <div className="space-y-1 mb-6">
          <p className="helper-text">
            {t(
              'settings.integrations.description',
              'Connect ScreenApp with your favorite tools and services.',
            )}
          </p>
        </div>

        {/* Zoom Integration */}
        {config.enableZoomIntegration && (
          <>
            <SettingsSection
              label={t('settings.integrations.zoomIntegration.title')}
              description={t(
                'settings.integrations.zoomIntegration.description',
                'Connect your Zoom account to automatically import recordings.',
              )}
              showSeparator={false}
            >
              <ZoomIntegration />
            </SettingsSection>

            <Separator />
          </>
        )}

        {/* Webhooks */}
        <div>
          <Webhooks />
        </div>

        <Separator />

        {/* Enterprise Features */}
        {!isPlan(['ENTERPRISE']) && (
          <SettingsSection
            label={t('settings.integrations.enterprise.title')}
            description={t(
              'settings.integrations.enterprise.advancedIntegrations.description',
            )}
            showSeparator={false}
          >
            <Button
              variant="minimal"
              onClick={() => setSalesDialogOpen(true)}
              className="text-black hover:text-black"
            >
              {t('team.contactSales', 'Contact Sales')}
            </Button>
          </SettingsSection>
        )}
      </div>

      {salesDialogOpen && (
        <ContactSalesDialog
          onClose={handleSalesDialogClose}
          formSource="Integrations Settings - Enterprise Enquiry"
        />
      )}
    </SettingsLayout>
  );
};

export default Integrations;
